import '.g{min-height:100%;}.ssr-plugin'
import '.h{width:100%;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.d{align-items:center;}.ssr-plugin'
import '.c{justify-content:center;}.ssr-plugin'
import '.e{width:100vw;}.ssr-plugin'
import '.b{height:100vh;}.ssr-plugin'
import { useEffect, useRef } from 'react'
import { Content } from './pages/Content'
import { Route, Router, Switch } from 'wouter'
import { styled } from 'inlines'
import { Countdown } from './pages/Countdown'
import { Contestants } from './pages/Contestants'
import { useContentQuery } from './hooks/useContentQuery'
import { TermsAndConditions } from './pages/TermsAndCondition'
import { PrivacyPolicy } from './pages/PrivacyPolicy'
import { Cart } from './pages/Cart'
import { ThankYou } from './pages/ThankYou'
import { Checkout } from './pages/Checkout'
import { VotingRules } from './pages/VotingRules'
import { createConfirmingLocationHook } from './hooks/useConfirmingLocation'
import { useAppCtx } from './providers/useAppCtx'
import { InfraDownPage } from './pages/InfraDownPage'
import { useTranslations } from './hooks/useTranslations'
import { capitalize } from '@based/ui'
import { Spinner } from './components/Spinner'
import './index.css'
import { useTheme } from './providers/useTheme'

export const App = () => {
  const { content } = useAppCtx()

  const { data: sequence = {} } = useContentQuery('sequence')
  const { data: edition = {}, loading } = useContentQuery('edition')
  const { data: dictionary = {} } = useTranslations('navigation')

  const ref = useRef<any>(null)

  const useConfirmingLocation = createConfirmingLocationHook(
    capitalize(dictionary?.navigation_confirmation ?? ''),
    ['/checkout'],
  )

  const isContent = sequence?.sequenceType === 'content'
  const isVoting = sequence?.sequenceType === 'voting'
  const isWinner = sequence?.sequenceType === 'winner'
  const isCountdown =
    isContent &&
    sequence?.countdown !== undefined &&
    sequence?.countdown > 0 &&
    typeof sequence?.countdown === 'number'
  const route = edition.name

  const { colors } = useTheme()

  if (loading) {
    return ref.current || <InfraDownPage loading />
  }

  const isLocalOrBased =
    typeof window !== 'undefined' &&
    (window.location.hostname.includes('based.dev') ||
      window.location.hostname === 'localhost' ||
      window.location.hostname === '127.0.0.1' ||
      /^192\.168\.\d{1,3}\.\d{1,3}$/.test(window.location.hostname) ||
      /^10\.\d{1,3}\.\d{1,3}\.\d{1,3}$/.test(window.location.hostname))

  const base = isLocalOrBased
    ? content === 'preview-content'
      ? `/preview/${route}`
      : `/${route}`
    : undefined

  return (
    <div className="g h"
      style={{
        background: colors.background,
      }}
    >
      {ref.current}
      <Router base={base} hook={useConfirmingLocation}>
        <Switch>
          <Route path="/">
            {isCountdown ? (
              <Countdown
                countdown={sequence.countdown}
                aria-label={{
                  nav: capitalize(dictionary?.main_navigation ?? ''),
                  footer: capitalize(dictionary?.footer_navigation ?? ''),
                }}
              />
            ) : isContent ? (
              <Content
                aria-label={{
                  nav: capitalize(dictionary?.main_navigation ?? ''),
                  footer: capitalize(dictionary?.footer_navigation ?? ''),
                }}
              />
            ) : isVoting ? (
              <Contestants
                aria-label={{
                  nav: capitalize(dictionary?.main_navigation ?? ''),
                  footer: capitalize(dictionary?.footer_navigation ?? ''),
                }}
              />
            ) : isWinner ? (
              <Content
                aria-label={{
                  nav: capitalize(dictionary?.main_navigation ?? ''),
                  footer: capitalize(dictionary?.footer_navigation ?? ''),
                }}
              />
            ) : (
              <div className="a d c e b"
              >
                <Spinner variant="black" />
              </div>
            )}
          </Route>

          <Route path="/terms-and-conditions">
            <TermsAndConditions
              aria-label={{
                nav: capitalize(dictionary?.main_navigation ?? ''),
                footer: capitalize(dictionary?.footer_navigation ?? ''),
              }}
            />
          </Route>

          <Route path="/privacy-policy">
            <PrivacyPolicy
              aria-label={{
                nav: capitalize(dictionary?.main_navigation ?? ''),
                footer: capitalize(dictionary?.footer_navigation ?? ''),
              }}
            />
          </Route>

          <Route path="/voting-rules">
            <VotingRules
              aria-label={{
                nav: capitalize(dictionary?.main_navigation ?? ''),
                footer: capitalize(dictionary?.footer_navigation ?? ''),
              }}
            />
          </Route>

          <Route path="/cart">
            <Cart
              aria-label={{
                nav: capitalize(dictionary?.main_navigation ?? ''),
                footer: capitalize(dictionary?.footer_navigation ?? ''),
              }}
            />
          </Route>

          <Route path="/checkout">
            <Checkout
              aria-label={{
                nav: capitalize(dictionary?.main_navigation ?? ''),
                footer: capitalize(dictionary?.footer_navigation ?? ''),
              }}
            />
          </Route>

          <Route path="/thank-you/*">
            <ThankYou
              aria-label={{
                nav: capitalize(dictionary?.main_navigation ?? ''),
                footer: capitalize(dictionary?.footer_navigation ?? ''),
              }}
              round={sequence?.round?.id}
            />
          </Route>
        </Switch>
      </Router>
    </div>
  )
}
